<template>
  <Form ref="carForm" :model="car" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate"
        :label-width="100">
    <input v-model="car.id" type="hidden"/>

    <FormItem :label="this.$t('travel.car.plateNo.label')" prop="plateNo">
      <Input v-model="car.plateNo" :placeholder="$t('travel.car.plateNo.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car.personId.label')" prop="personId">
      <Input v-model="car.personId" :placeholder="$t('travel.car.personId.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car.plateType.label')" prop="plateType">
      <Select v-model="car.plateType" :placeholder="$t('travel.car.plateType.holder')">
        <Option v-for="item in this.dict.plate_type" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car.plateColor.label')" prop="plateColor">
      <Select v-model="car.plateColor" :placeholder="$t('travel.car.plateColor.holder')">
        <Option v-for="item in this.dict.plate_color" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car.vehicleType.label')" prop="vehicleType">
      <Select v-model="car.vehicleType" :placeholder="$t('travel.car.vehicleType.holder')">
        <Option v-for="item in this.dict.car_type" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car.vehicleColor.label')" prop="vehicleColor">
      <Select v-model="car.vehicleColor" :placeholder="$t('travel.car.vehicleColor.holder')">
        <Option v-for="item in this.dict.car_color" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car.vipState.label')" prop="vipState">
      <Select v-model="car.vipState" :placeholder="$t('travel.car.vipState.holder')">
        <Option v-for="item in this.dict.vip_status" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car.vipBeginTime.label')" prop="vipBeginTime">
      <Date-picker :value="car.vipBeginTime" @on-change="vipBeginTimeFormat" type="datetime"
                   :placeholder="this.$t('travel.car.vipBeginTime.holder')"></Date-picker>
    </FormItem>

    <FormItem :label="this.$t('travel.car.vipEndTime.label')" prop="vipEndTime">
      <Date-picker :value="car.vipEndTime" @on-change="vipEndTimeFormat" type="datetime"
                   :placeholder="this.$t('travel.car.vipEndTime.holder')"></Date-picker>
    </FormItem>

    <FormItem :label="this.$t('travel.car.description.label')" prop="description">
      <Input v-model="car.description"
             :placeholder="$t('travel.car.description.holder')"/>
    </FormItem>

  </Form>
</template>
<script>
  import api from '@/api'

  export default {
    dictParams: ['plate_color', 'plate_type', 'car_color', 'car_type', 'vip_status'],
    data () {
      return {
        car: {
          id: null,
          plateNo: null,
          personId: null,
          plateType: null,
          plateColor: null,
          vehicleType: null,
          vehicleColor: null,
          vipState: 0,
          vipBeginTime: null,
          vipEndTime: null,
          description: null
        },
        loading: false,
        actionType: 'add'
      }
    },
    methods: {
      handleSubmit (then, error) {
        this.$refs['carForm'].validate(valid => {
          if (valid) {
            if (this.car.id) {
              this.updateCar(this.car).then(then).error(error)
            } else {
              this.createCar(this.car).then(then).error(error)
            }
          } else {
            this.$Message.error(this.$t('errorText'))
            error()
          }
        })
      },
      handleReset () {
        this.car.id = ''
        this.actionType = 'add'
        this.$nextTick(() => this.$refs['carForm'].resetFields())
      },
      getCar (id, type) {
        this.loading = true
        this.$refs['carForm'].resetFields()
        api.travel.Car.detail(id).then(data => {
          this.car.id = data.id
          this.car.description = data.id
          this.car.personId = data.personId
          this.car.plateColor = data.plateColor
          this.car.plateNo = data.plateNo
          this.car.plateType = data.plateType
          this.car.vehicleColor = data.vehicleColor
          this.car.vehicleType = data.vehicleType
          this.car.vipBeginTime = data.vipBeginTime
          this.car.vipEndTime = data.vipEndTime
          this.car.vipState = data.vipState
          this.car.description = data.description
          this.loading = false
          this.actionType = type
        }).catch(e => this.loading = false)
      },
      createCar (car) {
        this.loading = true
        return api.travel.Car.add(car)
          .then(response => {
            this.loading = false
            this.$Message.success(this.$t('successText'))
            return response
          })
          .catch(e => {
            this.loading = false
          })
      },
      updateCar (car) {
        this.loading = true
        return api.travel.Car.update(car)
          .then(response => {
            this.loading = false
            this.$Message.success(this.$t('successText'))
            return response
          })
          .catch(e => {
            this.loading = false
          })
      },
      vipBeginTimeFormat (str, date) {
        this.car.vipBeginTime = str ? str : ''
      },
      vipEndTimeFormat (str, date) {
        this.car.vipEndTime = str ? str : ''
      },
    },
    computed: {
      ruleValidate () {
        let validate = {
          plateNo: [{
            type: 'string',
            required: true,
            message: this.$t('travel.car.plateNo.required'),
            trigger: 'blur'
          }, { type: 'string', max: 10, message: this.$t('travel.car.plateNo.max'), trigger: 'blur' }],
          personId: [{ type: 'string', max: 20, message: this.$t('travel.car.personId.max'), trigger: 'blur' }],
          plateType: [{type: 'number', required: true, message: this.$t('travel.car.plateType.required'),trigger: 'blur'}],
          plateColor: [{type: 'number', required: true, message: this.$t('travel.car.plateColor.required'),trigger: 'blur'}],
          vehicleType: [{type: 'number', required: true, message: this.$t('travel.car.vehicleType.required'),trigger: 'blur'}],
          vehicleColor: [{type: 'number', required: true, message: this.$t('travel.car.vehicleColor.required'),trigger: 'blur'}],
          vipState: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car.vipState.required'),
            trigger: 'blur'
          }],
          vipBeginTime: [],
          vipEndTime: [],
          description: [{ max: 20, message: this.$t('travel.car.description.max'), trigger: 'blur' }]
        }
        if (this.actionType == 'edit') {
          this.$refs['carForm'].fields.forEach(f => {
            if (f.$children[0].disabled) {
              delete validate[f.prop]
            }
          })
        } else if (this.actionType == 'detail') {
          return {}
        }
        return validate
      }
    }
  }
</script>
